<template>
  <base-modal :show="show"
              @close="close"
              size="small">
    <div slot="header">
      {{ $t("schedule.scheduleChanged") }}
    </div>

    <div class="btn-group">
      <base-button class="btn-group-save"
                   color="primary"
                   @click="$emit('save')">
        {{ $t("saveChanges") }}
      </base-button>

      <div class="btn-group-discard"
           @click="$emit('discard')">
        {{ $t("discardChanges") }}
      </div>
    </div>
  </base-modal>
</template>

<script>
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    data() {
      return {
        fromBus: {
        }
      }
    },

    beforeMount() {
      this.setOpenListener('scheduleAlert')
    }
  }
</script>

<style lang="scss" scoped>
  .btn-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-top: 24px;

    &-save {
      width: 100%;
      height: 75px;

      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 29px;

      margin-bottom: 48px;
    }

    &-discard {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 24px;

      cursor: pointer;
    }
  }
</style>

